module.exports = __webpack_public_path__ + "img/campaign-image-placeholder.d81d54bf.svg";